export const binanceTemplate = {
    exchange: "Binance",
    fields: [
        { key: "currency", label: "Currency", placeholder: "eg. USDT", required: true },
        { key: "amount", label: "Deposit Amount", placeholder: "eg. 40", type: "number", required: true },
        { key: "exploreLink", label: "Explore Link", placeholder: "https://bscscan.com/tx/...", required: false },
        { key: "email", label: "Email (for alerts)", placeholder: "user@example.com", type: "email", required: true },
        { key: "fallbackEmail", label: "Support Email", placeholder: "support@example.com", type: "email", required: false },
    ],
};